import React, { ReactElement } from "react";
import ModalPopUp from './ModalPopUp';

 interface MessagePopUpTemporalProps {
     message: ReactElement,
     classNameStyle: string
}

const MessagePopUpTemporal: React.FC<MessagePopUpTemporalProps> = (props: MessagePopUpTemporalProps) => {
    return (
        <ModalPopUp classNameStyle={props.classNameStyle}>
            <div className="row justify-content-center">
                <div className="col-lg-12 col-sm-12 col-md-12 col-xs-12" >
                    {props.message}
                </div>
            </div>
        </ModalPopUp>
    );
};

export default MessagePopUpTemporal;